/**
 * withDarkModeCallsheetStyles.js
 * 
 * A higher-order component that provides theme-aware styles to Callsheet components
 */

import React from 'react';
import { useTheme } from '@mui/material/styles';
import getCallsheetStyles from './DarkModeCallsheetStyles';

/**
 * Higher-order component that wraps a component with theme-aware styles
 * @param {React.Component} Component - The component to wrap
 * @returns {React.Component} - The wrapped component with theme-aware styles
 */
const withDarkModeCallsheetStyles = (Component) => {
  const WithStyles = (props) => {
    const theme = useTheme();
    const styles = getCallsheetStyles(theme);
    
    return <Component {...props} styles={styles} />;
  };
  
  // Set display name for debugging
  WithStyles.displayName = `withDarkModeCallsheetStyles(${Component.displayName || Component.name || 'Component'})`;
  
  return WithStyles;
};

export default withDarkModeCallsheetStyles;
